import React from 'react';
import { DateTime } from 'luxon';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AlarmIcon from '@mui/icons-material/Alarm';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useNavigate } from 'react-router';
import Box from "@mui/material/Box";
import CountryWithFlag from "./country";

export default function EventList({ events }) {

  const navigate = useNavigate()

  const openEvent = eventId => {
    navigate(`/event/${eventId}`);
  }

  return (
    <React.Fragment>
      {events && events.map(event => {
        const format = "yyyy-MM-dd'T'HH:mm:ss'Z'";
        const parsedUtcTime = DateTime.fromFormat(event.time, format, { zone: 'utc' });
        const evtTime = parsedUtcTime.toLocal();
        const hasBet = event.my_bet && event.my_bet.score1 !== null && event.my_bet.score2 !== null;

        return <Box key={event.id} onClick={() => openEvent(event.id)}
          className={`cursor-pointer grid grid-cols-4 text-center border-2 mb-2 p-2`}>
          <div className={"col-span-3 border-r-2"}>
            <div className={"flex"}>
              <CountryWithFlag countryName={event.team1} />
              <p className={"text-yellow-300 px-2"}>VS</p>
              <CountryWithFlag countryName={event.team2} />
            </div>
            <p className={"text-left"}>
              <CalendarTodayIcon className={"text-amber-500"} />{evtTime.toFormat('yyyy-MM-dd')}
              <AlarmIcon className={"text-amber-500"} />{evtTime.toFormat('HH:mm')}
            </p>
          </div>
          {hasBet ? <div>
            <p>Bet {event.my_bet.score1}<span className={"text-yellow-300"}>:</span>{event.my_bet.score2} </p>
            {event.my_bet.points && <p className={"text-yellow-300"}>{event.my_bet.points}pts </p>}
          </div> : <p className={"text-red-500 text-center"}><WarningAmberIcon /> </p>}
        </Box>
      })}
    </React.Fragment>
  )
}